/* ==========================================================================
   Base Nico — sincronización del carrito
   1. Al volver con "atrás" (página restaurada desde la caché del navegador), Dawn muestra
      la burbuja y el drawer viejos. Acá se vuelven a pedir con section rendering
      (endpoint estándar: /?sections=cart-icon-bubble,cart-drawer).
   2. Contadores extra (ej. ícono de carrito para celular en un header propio): en vez de
      repetir id="cart-icon-bubble" (Dawn solo actualiza el primero), marcarlos con
      data-nico-cart-count. Se actualizan con cada evento cartUpdate de Dawn.
   No llama /cart/add ni /cart/change: no interfiere con los pixels ni con el JS de Dawn.
   ========================================================================== */
(() => {
  const parse = (html, sel) => new DOMParser().parseFromString(html, 'text/html').querySelector(sel);

  const setCounts = (n) => {
    document.querySelectorAll('[data-nico-cart-count]').forEach((el) => {
      el.textContent = n;
      el.toggleAttribute('hidden', n === 0);
    });
  };

  const sync = () => {
    const url = `${window.location.pathname}?sections=cart-icon-bubble,cart-drawer`;
    return fetch(url, { cache: 'no-store' })
      .then((r) => (r.ok ? r.json() : null))
      .then((s) => {
        if (!s) return;
        const bubble = document.getElementById('cart-icon-bubble');
        if (bubble && s['cart-icon-bubble']) {
          const nuevo = parse(s['cart-icon-bubble'], '.shopify-section');
          if (nuevo) bubble.innerHTML = nuevo.innerHTML;
        }
        const drawer = document.querySelector('cart-drawer');
        const actual = document.getElementById('CartDrawer');
        if (drawer && actual && s['cart-drawer']) {
          const nuevo = parse(s['cart-drawer'], '#CartDrawer');
          if (nuevo) {
            actual.innerHTML = nuevo.innerHTML;
            const overlay = document.getElementById('CartDrawer-Overlay');
            if (overlay && typeof drawer.close === 'function') overlay.addEventListener('click', drawer.close.bind(drawer));
          }
        }
        return fetch('/cart.js', { cache: 'no-store' })
          .then((r) => r.json())
          .then((c) => {
            setCounts(c.item_count);
            if (drawer) drawer.classList.toggle('is-empty', c.item_count === 0);
          });
      })
      .catch(() => {});
  };

  // "Atrás" puede restaurar la página de dos formas: desde bfcache (persisted) o recargándola
  // desde la caché HTTP (navigation type back_forward). En las dos, el HTML es viejo.
  window.addEventListener('pageshow', (e) => {
    const nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    if (e.persisted || (nav && nav.type === 'back_forward')) sync();
  });

  const engancharEventos = () => {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, (ev) => {
      const n = ev && ev.cartData && typeof ev.cartData.item_count === 'number' ? ev.cartData.item_count : null;
      if (n !== null) setCounts(n);
      else fetch('/cart.js', { cache: 'no-store' }).then((r) => r.json()).then((c) => setCounts(c.item_count)).catch(() => {});
      // 3. En /cart, cart.js de Dawn repinta main-cart-items/footer y la burbuja, pero NO el drawer
      //    (que sigue en el DOM). Se lo vuelve a pedir con section rendering para que no quede desfasado.
      if (document.getElementById('main-cart-items') && (!ev || ev.source !== 'nico-sync')) sync();
    });
  };

  // 4. Clics rápidos en + / − del drawer justo después de agregar: Dawn (CartDrawerItems.onCartUpdate)
  //    vuelve a pedir el drawer ~1 s después del /cart/add y reemplaza <cart-drawer-items>, pisando el
  //    clic pendiente → se pierde un clic y aparece «Puoi aggiungere soltanto N…». Si el usuario tocó el
  //    drawer mientras tanto, no se reemplaza: la respuesta de su /cart/change ya lo repinta.
  let ultimoToque = 0;
  const marcar = (e) => {
    if (e.target && e.target.closest && e.target.closest('cart-drawer-items')) ultimoToque = Date.now();
  };
  ['click', 'change', 'input'].forEach((t) => document.addEventListener(t, marcar, true));

  const protegerDrawer = () => {
    if (typeof CartDrawerItems === 'undefined' || CartDrawerItems.prototype.nicoProtegido) return;
    CartDrawerItems.prototype.onCartUpdate = function () {
      const inicio = Date.now();
      return fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((r) => r.text())
        .then((texto) => {
          if (ultimoToque >= inicio - 500) return;
          const html = new DOMParser().parseFromString(texto, 'text/html');
          ['cart-drawer-items', '.cart-drawer__footer'].forEach((sel) => {
            const actual = document.querySelector(sel);
            const nuevo = html.querySelector(sel);
            if (actual && nuevo) actual.replaceWith(nuevo);
          });
        })
        .catch((e) => console.error(e));
    };
    CartDrawerItems.prototype.nicoProtegido = true;
  };

  const iniciar = () => {
    engancharEventos();
    protegerDrawer();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
